<template>
    <div class="objectiveCard">
        <div class="objStockName">
            <div class="stockSymbol">{{ symbol }}</div>
            <CountryBadge :currency="currency"></CountryBadge>
            <div v-if="$vuetify.breakpoint.xs" class="objValueDesc2">{{ objectifDesc }}</div>
        </div>
        <div v-if="$vuetify.breakpoint.smAndUp">
            <div class="objDetails">
                <div class="objPrimary">{{ $t('Home.dashboard.overview.objectivesOverview.currently') }}</div>
                <div class="objValue">{{ value }}{{ suffix }}</div>
            </div>
            <div class="objDetails">
                <div class="objPrimary">{{ $t('Home.dashboard.overview.objectivesOverview.objective') }}</div>
                <div class="objValue">
                    <span>{{ objectiveValue }}{{ suffix }}</span>
                    <span class="objValueDesc">{{ objectifDesc }}</span>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="objDetails">
                <div class="objPrimary">{{ $t('Home.dashboard.overview.objectivesOverview.currentOverObjective') }}</div>
                <div class="objValue">{{ value }} / {{ objectiveValue }}{{ suffix }}</div>
            </div>
        </div>
        <div class="objDetails">
            <div class="objPrimary">{{ $t('Home.dashboard.overview.objectivesOverview.progress') }}</div>
            <div class="objValue">
                <v-progress-linear :value="percentage" height="20" color="success" dark>
                    <template v-slot:default="{ value }">
                        <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                </v-progress-linear>
            </div>
        </div>
    </div>
</template>

<script>
import CountryBadge from './CountryBadge.vue';
export default {
	components: { CountryBadge },
    props: ['objective'],
    data() {
        return {
            prog: 80
        };
    },
    computed: {
        stock() {
            return this.$store.getters.getStockInfoById(this.objective.stockId);
        },
        symbol() {
            return this.$store.getters.getStockInfoById(this.objective.stockId).symbol
        },
        currency() {
            return this.stock.currency;
        },
        objectiveValue() {
            return this.objective.target;
        },
        objectifDesc() {
            return this.$t(`stockPage.objectives.${this.objective.type}.label`);
        },
        value() {
            return Math.round(this.objective.value);
        },
        suffix() {
            switch (this.objective.type) {
                case 'percentageOfTotalInvestmentValue':
                    return '%';
                case 'totalTargetedShareCount':
                    return ' actions';
                default:
                    return '';
            }
        },
        value2() {
            switch (this.objective.type) {
                case 'percentageOfTotalInvestmentValue':
                    return Math.round(this.objective.actualPercentage);
                case 'totalTargetedShareCount':
                    return this.objective.actualShareCount;
                default:
                    return 0;
            }
        },
        percentage() {
            return Math.round(this.objective.percentageOfProgression);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/breakpoints.scss';
.objectiveCard{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    padding: 10px;
    border: solid 1px #ccc;
    .objStockName{
        font-size: 1.2em;
        color: #333;
        display: flex;
        align-items: center;
        gap: 10px;
        .stockSymbol{
            font-weight: bold;
        }
        .objValueDesc2 {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            font-size: 0.7em;
            color: #666;
            font-style: italic;
        }
    }
    .objDetails{
        display: flex;
        justify-content: space-between;
        gap: 10px;
        .objPrimary{
            flex: 1;
            font-size: 0.9em;
            color: #666;
        }
        .objValue{
            display: flex;
            align-items: center;
            gap: 8px;
            flex: 2;
            font-size: 1.1em;
            color: #000;
            font-weight: bold;
            .objValueDesc {
                font-weight: normal;
                font-size: 0.8em;
                color: #666;
                font-style: italic;
            }
        }
    }
    @media screen and (max-width: $phone){
        .objValue{
            justify-content: flex-end;
        }
    }
}
</style>